export const PATHS = {
  login: '/login',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  connects: '/connects',
  connectsContacts: '/connects/contacts',
  connectsTodo: '/connects/todo',
  connectsEmail: '/connects/email',
  connectsPipeline: '/connects/pipeline',
  connectsActivity: '/connects/activity',
  users: '/users',
  paymentGateways: '/payment-gateways',
  plans: '/plans',
  emailConfig: '/email-configuration',
  loginLogs: '/login-logs',
  profile: '/profile',
  changePassword: '/change-password',
  notifications: '/notifications',
} as const

export type AppPath = (typeof PATHS)[keyof typeof PATHS]
